// Dimensions of different modes' overlays

export const PictureHeight = 1280;
export const PictureWidth = 1920;

export const LandscapeStripWidth = 3840;
export const LandscapeStripHeight = 2560;

export const GifWidth = 900;
export const GifHeight = 600;

export const BoomerangWidth = 450;
export const BoomerangHeight = 300;

export const MaskSide = 512;



// WEBPACK FOOTER //
// ./src/constants/photoDimensions.js